import { normalizeBaseUrl } from '@/helpers/tenantUrlHelper';
import { CrudService } from '@/services/crudService';

type BookingCommentPayload = {
  bookingId: number | string;
  tenantUrl?: string | null;
  comment?: string | null;
};

export async function saveBookingComment(options: BookingCommentPayload) {
  const baseUrl = normalizeBaseUrl(options.tenantUrl);

  if (!baseUrl) {
    throw new Error('Tenant URL no disponible para guardar comentario');
  }

  const crud = new CrudService({
    baseUrl,
    allowAuth: true,
    handleUnauthorized: false,
  });

  const payload = {
    comment: options.comment ?? null,
  };

  const response = await crud.httpPost(
    `/api/publicbookings/comment-market/${options.bookingId}`,
    payload,
    undefined,
    'json',
    {
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      baseUrl,
      handleUnauthorized: false,
    }
  );

  return response;
}
